import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import {
  HeaderDescription,
  Layout,
  NewsLetterBar,
  ReadyToSeePossibilities,
  SharedHero,
  TrustedByContractors,
} from '../../v2/components/common';
import {
  CaseStudies,
  FitIntoYourBusiness,
  MarketingAndSales,
  Production,
} from '../../v2/components/exterior-contractors';
import { URLS } from '../../v2/constants';

const ExteriorContractors: React.FC = () => (
  <Layout
    title="Retail Contractors | Exterior Home Improvement"
    description="HOVER transforms smartphone photos into accurate measurements for any property. Learn how HOVER can drive efficiencies for your home improvement business."
    buttonType="CHAT_WITH_A_REP"
  >
    <SharedHero
      heading="Build your business with HOVER."
      body="Accurate measurements, fast estimates, direct orders, and happier
            customers mean more time and money to build your business."
      chatWithUsLink={URLS.exteriorContractors.chatWithUs}
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/exterior_contractors_hero_desktop.png"
          alt="exterior-contractors-hero"
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/exterior_contractor_hero_tablet.png"
          alt="exterior-contractors-hero"
        />
      }
    />
    <HeaderDescription
      mb={{ base: '72px', desktop: 1100 }}
      heading="HOVER saves you time, money and unnecessary headaches."
      body="We help you connect and collaborate with homeowners, to make jobs simpler
      and more transparent. We offer direct ordering, production management,
      remote measurements and automated estimates to make jobs more cost
      effective and more efficient."
    />
    <MarketingAndSales />
    <Production />
    <CaseStudies />
    <FitIntoYourBusiness />
    <ReadyToSeePossibilities body="Whether you’re a small business, a national team, or somewhere in between, we can help." />
    <TrustedByContractors />
    <NewsLetterBar showForm showViewJobs={false} />
  </Layout>
);

export default ExteriorContractors;
